/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClientAuthorizationPropertyType } from './ClientAuthorizationPropertyType';
import {
    ClientAuthorizationPropertyTypeFromJSON,
    ClientAuthorizationPropertyTypeFromJSONTyped,
    ClientAuthorizationPropertyTypeToJSON,
    ClientAuthorizationPropertyTypeToJSONTyped,
} from './ClientAuthorizationPropertyType';

/**
 * 
 * @export
 * @interface UpdateAuthorizationPropertyRequest
 */
export interface UpdateAuthorizationPropertyRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateAuthorizationPropertyRequest
     */
    mpk: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAuthorizationPropertyRequest
     */
    value: string;
    /**
     * 
     * @type {ClientAuthorizationPropertyType}
     * @memberof UpdateAuthorizationPropertyRequest
     */
    propertyType: ClientAuthorizationPropertyType;
}



/**
 * Check if a given object implements the UpdateAuthorizationPropertyRequest interface.
 */
export function instanceOfUpdateAuthorizationPropertyRequest(value: object): value is UpdateAuthorizationPropertyRequest {
    if (!('mpk' in value) || value['mpk'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('propertyType' in value) || value['propertyType'] === undefined) return false;
    return true;
}

export function UpdateAuthorizationPropertyRequestFromJSON(json: any): UpdateAuthorizationPropertyRequest {
    return UpdateAuthorizationPropertyRequestFromJSONTyped(json, false);
}

export function UpdateAuthorizationPropertyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAuthorizationPropertyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'mpk': json['mpk'],
        'value': json['value'],
        'propertyType': ClientAuthorizationPropertyTypeFromJSON(json['propertyType']),
    };
}

export function UpdateAuthorizationPropertyRequestToJSON(json: any): UpdateAuthorizationPropertyRequest {
    return UpdateAuthorizationPropertyRequestToJSONTyped(json, false);
}

export function UpdateAuthorizationPropertyRequestToJSONTyped(value?: UpdateAuthorizationPropertyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mpk': value['mpk'],
        'value': value['value'],
        'propertyType': ClientAuthorizationPropertyTypeToJSON(value['propertyType']),
    };
}

